<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { RouterView } from "vue-router";
import { useWorkspaceStore } from "@/stores/workspace";

const workspace = useWorkspaceStore();

function reconcileVisibleWorkspace() {
  if (document.visibilityState === "visible")
    void workspace.reconcileWorkspaceFromApi();
}

onMounted(() => {
  workspace.restoreSession();
  window.addEventListener("focus", reconcileVisibleWorkspace);
  document.addEventListener("visibilitychange", reconcileVisibleWorkspace);
});
onBeforeUnmount(() => {
  window.removeEventListener("focus", reconcileVisibleWorkspace);
  document.removeEventListener("visibilitychange", reconcileVisibleWorkspace);
});
</script>

<template>
  <RouterView />
  <div class="sr-only" aria-live="polite">{{ workspace.announcement }}</div>
</template>
